<app-branchchampions
  [branchChampions]="(branchChampions$ | async)!"
  (filterChange)="onFilterChange($event)"
  [loading]="!!(loading$ | async)"
  [theme]="theme"
></app-branchchampions>
